import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme, Checkbox } from '@mui/material'
import { FilterInput } from '../../common/filterInput'
import DropDownOA from '../../common/dropDownOA'
import LineInputV3 from '../../common/lineInputV3'
import { cellStyles, headCellStyles, paymentTypeStyles, excelHeadCellStyles } from './const'
import { clickElement, filterData, focusElemnt, getPaymentTypeBackground, isValueinObjectArray } from '../../common/helper'
import moment from 'moment'
import { columnDefsTwo } from './DeliveryMemoTableDefs'
import { useAtom } from 'jotai'
import { sourceCityAtom } from '../../common/jotaiState/deliverymemoStateAtoms'
import { destinationCityAtom } from '../../common/jotaiState/deliverymemoStateAtoms'
const DeliveryMemoTableTwo = (props) => {
  const {data, methods}=props;
  const { appliedMoreFilter, tableData, loginData, memoFromDate, memoToDate, driverInfo, brnchList,
     vehicleList, selectedLrs, showMore } = data
  const theme = useTheme()
  const { palette: cs } = theme
  const [calcwidth1, setWidth1] = useState(0)
  const [calcwidth2, setWidth2] = useState(0)
  const [filterValues, setFilterValues] = useState({});
  const [filteredData, setfilteredData] = useState(tableData)
  const [sourceCity ] = useAtom(sourceCityAtom)
  const [destinationCity] = useAtom(destinationCityAtom) 
  const {
    bulkDeliveryCheck = false,
    brnchForDelivery,
    trnsfrVehicle,
    driverName,
    remark,
  } = data;
  useEffect(()=>setfilteredData(tableData),[tableData])
  const handleChangeContain = (e, name) => {
   let value=e.target.value;
   setFilterValues((prevFilterValues) => ({
     ...prevFilterValues,
     [name]: value
   }));
  }
  useEffect(()=>{
    const filteredDataTemp = tableData.filter((item) => {
      return columnDefsTwo.every((column) => {
        const filterValue = filterValues[column.field] || "";
        const value = item[column.field]
        return filterValue ? value && value.toString().toLowerCase().includes(filterValue.toLowerCase()) : true
      })
    })
    setfilteredData(filteredDataTemp)
  },[filterValues])
  const chkBoxNavigation = (e, nextId, prevId) => {
    if (e.key === 'ArrowUp') {
      focusElemnt(prevId)
    }
    if (e.key === 'ArrowDown') {
      focusElemnt(nextId)
      e.preventDefault()
    }
    if (e.key === 'Enter') {
      focusElemnt('memoBrnchForDeliveryTransfer')
      e.preventDefault()
    }
  }
  return (<>
      <TableContainer
        className="delivery-memo-table scroll"
        component={Paper}
        sx={{border:'1px solid #aeaeae', borderRadius: '8px', height:showMore? 'calc( 50vh - 120px)':'calc( 70vh - 100px)', overflow: 'auto', margin:'0px 0px 0px 5px' }}
      >
        <Table aria-label="a dense table" id='delivery-memo-tbl-two'>
          <TableHead className="table-consignment-head" style={{ position: 'sticky', top: '0', background: cs.primary.main, zIndex: 2 }}>
            <TableRow>
             <TableCell style={{ ...headCellStyles, width: '2%', textAlign: 'center', borderTopLeftRadius: '8px' }}>
                <Checkbox id="memoTableHeadCheck"  style={{ color: 'white'  }} />
              </TableCell>
              <TableCell style={{ ...headCellStyles, width: '7%',backgroundColor: '#0086ff' }}>LR<br/>Number</TableCell>
              <TableCell style={{ ...headCellStyles, width: '5%',backgroundColor: '#0086ff' }}>Offline<br/>LR No.</TableCell>
              <TableCell style={{ ...headCellStyles, width: '4%',backgroundColor: '#0086ff' }}>Payment<br/>Type</TableCell>
              <TableCell style={{ ...headCellStyles, width: '7%',backgroundColor: '#0086ff' }}>Source<br/>City</TableCell>
              <TableCell style={{ ...headCellStyles, width: '7%',backgroundColor: '#0086ff' }}>Destination<br/>City</TableCell>
              <TableCell style={{ ...headCellStyles, width: '7%',backgroundColor: '#0086ff' }}>Destination<br/>Branch</TableCell>
              <TableCell style={{ ...headCellStyles, width: '7%',backgroundColor: '#0086ff' }}>Current<br/>Branch</TableCell>
              <TableCell style={{ ...headCellStyles, width: '6%',backgroundColor: '#0086ff' }}>Receive<br/>Date</TableCell>
              <TableCell style={{ ...headCellStyles, width: '4%',backgroundColor: '#0086ff' }}>Total<br/>Units</TableCell>
              <TableCell style={{ ...headCellStyles, width: '3%',backgroundColor: '#0086ff' }}>LR Due<br/>Amount</TableCell>
              <TableCell style={{ ...headCellStyles, width: '11%',backgroundColor: '#0086ff' }}>Branch For<br/>Delivery Transfer </TableCell>
              <TableCell style={{ ...headCellStyles, width: '9%',backgroundColor: '#0086ff' }}>Transf. By<br/> Vehicle No.</TableCell>
              <TableCell style={{ ...headCellStyles, width: '9%',backgroundColor: '#0086ff' }}> Driver<br/>Name</TableCell>
              <TableCell style={{ ...headCellStyles, width: '10%',backgroundColor: '#0086ff', borderTopRightRadius: '8px' }}>Transfer <br/>Remarks if Any</TableCell>
            </TableRow>
            <TableRow style={{ position: 'sticky', top: '0', zIndex: 3, background: '#fff' }}>
              <TableCell style={{ ...cellStyles, textAlign: 'center' }}>
              <Checkbox id="memoFilterCheck" sx={{
                    color: "#ffffff",
                    "&.Mui-checked": {
                      color: "#ffffff",
                    },
                  }} style={{ '&$checked': { color: '#ffffff' } }} />
                 </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e)=>{handleChangeContain(e,'LRNO')}}/>
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e)=>{handleChangeContain(e,'ManualLRNo')}} />
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e)=>{handleChangeContain(e,'PaymentType')}}/>
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e)=>{handleChangeContain(e,'SourceCity')}}/>
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e)=>{handleChangeContain(e,'DestinationCity')}}/>
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e)=>{handleChangeContain(e,'DestinationBranch')}}/>
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e)=>{handleChangeContain(e,'CurrentBranch')}}/>
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e)=>{handleChangeContain(e,'ReceiptDate')}}/>
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e)=>{handleChangeContain(e,'Units')}}/>
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e)=>{handleChangeContain(e,'TotalDues')}}/>
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} disabled/>
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} disabled/>
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} disabled/>
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} disabled/>
                </Box>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.map((el, index) => (
              <DeliveryMemoRow key={'table-memo' + index} index={index} data={el} cs={cs} calcwidth1={calcwidth1} calcwidth2={calcwidth2}  driverInfo={driverInfo} brnchList={brnchList} vehicleList={vehicleList}
              propData={data} methods={methods} chkBoxNavigation={chkBoxNavigation} filteredData={filteredData}/>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TableContainer
        component={Paper}
        sx={{ borderRadius: '8px', border: '0px solid #ccc', height: 'calc( 66vh - 100px)', overflow: 'auto',display: 'none' }}
      >
        <Table aria-label="a dense table" id='delivery-memo-excel-tbl'>
        <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
            <TableRow>
              <TableCell
                className="reportTD"
                style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left' }}
                colSpan={7}
              >
                <h3 style={{ paddingLeft: '17px', fontSize:'18px' }}>Delivery Memo: Pending My Delivery At Other Branch</h3>
              </TableCell>
              <TableCell
                className="reportTD"
                style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left' }}
                colSpan={7}
              >
                <h3 style={{ paddingLeft: '17px', fontSize:'18px' }}>Company Name : {loginData.strCompanyName}</h3>
              </TableCell>
            </TableRow>
            <TableRow ><TableCell colSpan={14}></TableCell></TableRow>
            <TableRow style={{ color: '#444444' }}>
              <TableCell className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={4}
              >
                From Memo Date
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                To Memo Date
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={4}
              >
                Source City
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={4}
              >
                Destination City
              </TableCell>
            </TableRow>
            <TableRow >
            <TableCell
              className="ReportItemHead"
              style={{
                fontWeight: 'bold', color: 'black', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
              }}
              colSpan={4}
            >
              {moment(memoFromDate).format("DD-MM-YYYY")}
            </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={2}
              >
                {moment(memoToDate).format("DD-MM-YYYY")}
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={4}
              >
                {sourceCity.map((item) => item.sourceCityList).join(', ')}
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={4}
              >
                {destinationCity.destinationCityName}
              </TableCell>
            </TableRow>
            <TableRow ><TableCell colSpan={14}></TableCell></TableRow>
            {Object.keys(appliedMoreFilter).length!==0 && <TableRow  style={{ color: '#444444' }}>
             {appliedMoreFilter?.hasOwnProperty('PaymentType') && <TableCell className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Payment Type
              </TableCell>}
             {appliedMoreFilter?.hasOwnProperty('ChallanNo') && <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Challan No.
              </TableCell>}
             {appliedMoreFilter?.hasOwnProperty('LRNO') && <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                LR No.
              </TableCell>}
             {appliedMoreFilter?.hasOwnProperty('ManualLRNo') &&  <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Offline LR No.
              </TableCell>}
             {appliedMoreFilter?.hasOwnProperty('Sender') &&  <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={3}
              >
                Sender
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('SenderMobileNo') &&  <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Sender No.
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('SenderGSTN') &&  <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Sender GSTIN
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('SenderEmailID') &&  <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Sender Email ID
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('RecName') &&  <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Receiver
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('RecMobileNo') &&  <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Receiver No.
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('ReceiverEmailID') &&  <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Receiver Email ID
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('ReceiverGSTN') &&  <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Receiver GSTIN
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('PinCode') &&  <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Pincode
              </TableCell>}
            </TableRow>}

            <TableRow style={{ color: '#444444' }}>
              {appliedMoreFilter?.hasOwnProperty('PaymentType') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={2}
              >
               {appliedMoreFilter?.PaymentType}
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('ChallanNo') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={2}
              >
                {appliedMoreFilter?.ChallanNo}
              </TableCell>}
             {appliedMoreFilter?.hasOwnProperty('LRNO') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={2}
              >
                {appliedMoreFilter?.LRNO}
              </TableCell>}
             { appliedMoreFilter?.hasOwnProperty('ManualLRNo') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={2}
              >
                {appliedMoreFilter?.ManualLRNo}
              </TableCell>}
              { appliedMoreFilter?.hasOwnProperty('Sender') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={3}
              >
                {appliedMoreFilter?.Sender}
              </TableCell>}
              { appliedMoreFilter?.hasOwnProperty('SenderMobileNo') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
               colSpan={2}
              >
                {appliedMoreFilter?.SenderMobileNo}
              </TableCell>}
              { appliedMoreFilter?.hasOwnProperty('SenderGSTN') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
               colSpan={2}
              >
                {appliedMoreFilter?.SenderGSTN}
              </TableCell>}
              { appliedMoreFilter?.hasOwnProperty('SenderEmailID') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
               colSpan={2}
              >
                {appliedMoreFilter?.SenderEmailID}
              </TableCell>}
              { appliedMoreFilter?.hasOwnProperty('RecName') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
               colSpan={2}
              >
                {appliedMoreFilter?.RecName}
              </TableCell>}
              { appliedMoreFilter?.hasOwnProperty('RecMobileNo') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
               colSpan={2}
              >
                {appliedMoreFilter?.RecMobileNo}
              </TableCell>}
              { appliedMoreFilter?.hasOwnProperty('ReceiverEmailID') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
               colSpan={2}
              >
                {appliedMoreFilter?.ReceiverEmailID}
              </TableCell>}
              { appliedMoreFilter?.hasOwnProperty('ReceiverGSTN') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
               colSpan={2}
              >
                {appliedMoreFilter?.ReceiverGSTN}
              </TableCell>}
              { appliedMoreFilter?.hasOwnProperty('PinCode') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize:'16px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
               colSpan={2}
              >
                {appliedMoreFilter?.PinCode}
              </TableCell>}
            </TableRow>
            <TableRow ><TableCell colSpan={14}></TableCell></TableRow>
          </TableHead>
          <TableHead className="table-consignment-head" style={{ position: 'sticky', top: '0', background: cs.primary.main, zIndex: 2 }}>
            <TableRow>
              <TableCell style={{ ...excelHeadCellStyles, fontSize:'16px', width: '7%',backgroundColor: '#0086ff' }}>LR<br/>Number</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize:'16px', width: '5%',backgroundColor: '#0086ff' }}>Offline<br/>LR No.</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize:'16px', width: '4%',backgroundColor: '#0086ff' }}>Payment<br/>Type</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize:'16px', width: '7%',backgroundColor: '#0086ff' }}>Source<br/>City</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize:'16px', width: '7%',backgroundColor: '#0086ff' }}>Destination<br/>City</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize:'16px', width: '7%',backgroundColor: '#0086ff' }}>Destination<br/>Branch</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize:'16px', width: '7%',backgroundColor: '#0086ff' }}>Current<br/>Branch</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize:'16px', width: '6%',backgroundColor: '#0086ff' }}>Receive<br/>Date</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize:'16px', width: '4%',backgroundColor: '#0086ff' }}>Total<br/>Units</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize:'16px', width: '3%',backgroundColor: '#0086ff' }}>LR Due<br/>Amount</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize:'16px', width: '11%',backgroundColor: '#0086ff' }}>Branch For<br/>Delivery Transfer </TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize:'16px', width: '9%',backgroundColor: '#0086ff' }}>Transfer<br/>By Vehicle No.</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize:'16px', width: '9%',backgroundColor: '#0086ff' }}> Driver<br/>Name</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize:'16px', width: '10%',backgroundColor: '#0086ff', borderTopRightRadius: '8px' }}>Transfer <br/>Remarks if Any</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.map((data, index) => (
              <TableRow key={`memo-tbl-${index}`}>
      <TableCell style={{...cellStyles, fontSize:'16px'}}>
        <Box>
        <Typography>{`\u200B${data.LRNO}`}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, fontSize:'16px'}}>
        <Box>
        <Typography>{`\u200B${data?.ManualLRNo}`}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, fontSize:'16px'}}>
        <Box>
        <div style={{...paymentTypeStyles}} ><span style={{backgroundColor:getPaymentTypeBackground(data?.PaymentType), padding: '4px 9px', borderRadius: '30px',fontSize:'16px', textDecoration:data?.PaymentType?.length>7?'underline':''}} title={data?.PaymentType}>{data?.PaymentType}</span></div>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, fontSize:'16px'}}>
        <Box>
        <Typography>{data?.SourceCity}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, fontSize:'16px'}}>
        <Box>
        <Typography>{data?.DestinationCity}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, fontSize:'16px'}}>
        <Box>
        <Typography style={{ padding: 0,display:'block',textOverflow:'ellipsis',textDecoration:data?.DestinationBranch?.length>15?'underline':'',whiteSpace:'nowrap',overflow:'hidden',width:'8vw' }} title={data.DestinationBranch} > {data.DestinationBranch}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, fontSize:'16px'}}>
        <Box>
        <Typography style={{ padding: 0,display:'block',textOverflow:'ellipsis',textDecoration:data?.CurrentBranch?.length>15?'underline':'',whiteSpace:'nowrap',overflow:'hidden',width:'8vw' }} title={loginData.strBranchName} >{data?.CurrentBranch!==loginData.strBranchName?loginData?.strBranchName:data?.CurrentBranch}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, fontSize:'16px'}}>
        <Box>
        <Typography >{data.ReceiptDate}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, fontSize:'16px'}}>
        <Box>
        <Typography style={{textAlign: 'right'}}>{data.Units}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, fontSize:'16px'}}>
        <Box>
        <Typography style={{textAlign: 'right'}}>{data.TotalDues}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, fontSize:'16px'}}>
     { isValueinObjectArray(selectedLrs, data?.BookingID, 'BookingID')&&brnchForDelivery?.BranchName!==''?brnchForDelivery?.BranchName:''}
      </TableCell>
      <TableCell style={{...cellStyles, fontSize:'16px'}}>
      {isValueinObjectArray(selectedLrs, data?.BookingID, 'BookingID')&& trnsfrVehicle?.VehicleNo!==''?trnsfrVehicle?.VehicleNo:''}
      </TableCell>
      <TableCell style={{...cellStyles, fontSize:'16px'}}>
      {isValueinObjectArray(selectedLrs, data?.BookingID, 'BookingID')&& driverName?.DriverConductorName!==''?driverName?.DriverConductorName:''}
      </TableCell>
      <TableCell style={{...cellStyles, fontSize:'16px'}}>
      {isValueinObjectArray(selectedLrs, data?.BookingID, 'BookingID')&& remark!==''?remark:''}
        </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      </>
  )
}
const DeliveryMemoRow = (props) => {
  const { cs, index, data,driverInfo, brnchList, vehicleList, chkBoxNavigation, filteredData} = props
  const {propData, methods} = props;
  const { selectedLrs, loginData } = propData
  const {updateSelectedList1} = methods
  const [branchListData, setBranchListData] = useState([])
  const isChecked = isValueinObjectArray(selectedLrs, data?.BookingID, 'BookingID')
  const [transferVehicle, setTransferVehicle] = useState('')
  const [delBranch, setDelBranch] = useState('')
  const [transDriverName, setTransDiverName] = useState('')
  const {
    bulkDeliveryCheck = false,
    brnchForDelivery,
    trnsfrVehicle,
    driverName,
    remark,
  } = isChecked ? propData : {}
  const {  setSelectedLrs,
    setBrnchForDelivery, setTrnsfrVehicle,
    setDriverName, setRemark } = methods
    const isDisabled = bulkDeliveryCheck || !isChecked

    useEffect(()=>{
      let newList=brnchList.filter((item)=>item.BranchID!==loginData.intBranchID)
      setBranchListData(newList)
    },[brnchList])

    useEffect(()=>{
      if(brnchForDelivery!==''){
        setDelBranch(brnchForDelivery)
      }else{
        setDelBranch(' ')
      }
    },[brnchForDelivery])
    useEffect(()=>{
      if(trnsfrVehicle!==''){
        setTransferVehicle(trnsfrVehicle)
      }else{
        setTransferVehicle(' ')
      }
    },[trnsfrVehicle])
    useEffect(()=>{
      if(driverName!==''){
        setTransDiverName(driverName)
      }else{
        setTransDiverName(' ')
      }
    },[driverName])
  return (
    <TableRow>
     <TableCell style={{ ...cellStyles, textAlign: 'center', border: 'none', borderBottom: '1px solid #ddd' }}>
        <Checkbox 
        id={'memoTablerowCheck' + index} 
        onChange={(e) => updateSelectedList1(e, data, selectedLrs, setSelectedLrs)}
        onKeyDown={(e)=>chkBoxNavigation(e,index<filteredData?.length?`memoTablerowCheck${index+1}`:'memoTablerowCheck0', index===0?'memoExportPdfBtn':`memoTablerowCheck${index-1}`)}
         />
      </TableCell>
      <TableCell style={{...cellStyles, border: 'none', borderBottom: '1px solid #ddd',textAlign:'left'}}>
        <Box>
        <Typography>{data?.LRNO}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, border: 'none', borderBottom: '1px solid #ddd'}}>
        <Box>
        <Typography>{data?.ManualLRNo}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, border: 'none', borderBottom: '1px solid #ddd'}}>
        <Box>
        <div style={{...paymentTypeStyles}} ><span style={{backgroundColor:getPaymentTypeBackground(data?.PaymentType), padding: '4px 9px', borderRadius: '30px', textDecoration:data?.PaymentType?.length>7?'underline':''}} title={data?.PaymentType}>{data?.PaymentType}</span></div>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, border: 'none', borderBottom: '1px solid #ddd'}}>
        <Box>
        <Typography>{data?.SourceCity}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, border: 'none', borderBottom: '1px solid #ddd'}}>
        <Box>
        <Typography>{data?.DestinationCity}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, border: 'none', borderBottom: '1px solid #ddd'}}>
        <Box>
        <Typography style={{ padding: 0,display:'block',textOverflow:'ellipsis',textDecoration:data?.DestinationBranch?.length>15?'underline':'',whiteSpace:'nowrap',overflow:'hidden',width:'8vw' }} title={data.DestinationBranch} > {data.DestinationBranch}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, border: 'none', borderBottom: '1px solid #ddd'}}>
        <Box>
        <Typography style={{ padding: 0,display:'block',textOverflow:'ellipsis',textDecoration:data?.CurrentBranch?.length>15?'underline':'',whiteSpace:'nowrap',overflow:'hidden',width:'8vw' }} title={loginData.strBranchName} >{data?.CurrentBranch!==loginData.strBranchName?loginData?.strBranchName:data?.CurrentBranch}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, border: 'none', borderBottom: '1px solid #ddd'}}>
        <Box>
        <Typography >{data.ReceiptDate}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, border: 'none', borderBottom: '1px solid #ddd'}}>
        <Box>
        <Typography style={{textAlign: 'right'}}>{data.Units}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, border: 'none', borderBottom: '1px solid #ddd'}}>
        <Box>
        <Typography style={{textAlign: 'right'}}>{data.TotalDues}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, border: 'none', borderBottom: '1px solid #ddd'}}>
        <Box>
        <DropDownOA  label="Branch" data={branchListData || []} dataKey={`BranchName`} idKey={`BranchID`} listWidth={240} resetFlag={!bulkDeliveryCheck} onSelResetVal={true}
            value={delBranch?.BranchName||delBranch} defaultvalue={delBranch?.BranchName||delBranch} onSelect={(value) => {setBrnchForDelivery(value) }} disabled={isDisabled} noCross={true}/>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, border: 'none', borderBottom: '1px solid #ddd'}}>
        <Box>
        <DropDownOA  label='Veh. No.' data={vehicleList || []} listWidth={170} dataKey={`VehicleNo`} idKey={`VehicleID`} resetFlag={!bulkDeliveryCheck} onSelResetVal={true}
            value={transferVehicle?.VehicleNo||transferVehicle} defaultvalue={transferVehicle?.VehicleNo||transferVehicle} onSelect={(value) => setTrnsfrVehicle(value)} disabled={isDisabled} noCross={true}/>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, border: 'none', borderBottom: '1px solid #ddd'}}>
        <Box>
        <DropDownOA  label='Driver Name' data={driverInfo || []} listWidth={170}  dataKey={`DriverConductorName`} resetFlag={!bulkDeliveryCheck} onSelResetVal={true}
            idKey={`DriverConductorID`} value={transDriverName?.DriverConductorName||transDriverName} defaultvalue={transDriverName?.DriverConductorName||transDriverName} onSelect={(value) => {setDriverName(value)}} disabled={isDisabled} noCross={true}/>
        </Box>
      </TableCell>
      <TableCell style={{...cellStyles, border: 'none', borderBottom: '1px solid #ddd'}}>
        <Box>
        <LineInputV3 style={{textAlign: 'center'}} placeholder="Remark" value={remark ||''} onBlur={(e)=>{setRemark(e.target.value)}} disabled={isDisabled}/>
        </Box>
      </TableCell>
    </TableRow>
  )
}
export default DeliveryMemoTableTwo
